// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5782":"b6d70103","6262":"76e73391","9393":"63bea536","9949":"76e73391"}[chunkId] + ".chunk.css";
};